// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eligibility-assessment .sv_container{background-color:#fff}.eligibility-assessment .sv_row{display:block}.eligibility-assessment .sv_main .sv_p_root>.sv_row{padding-bottom:0px}.eligibility-assessment .sv_q_description{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
